"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
var _sys_cons = require("@/api/sys_cons");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  name: 'RedPacketPrizePane',
  components: {},
  props: {
    value: {
      type: Object,
      default: function _default() {
        return {
          prizeType: 1,
          couponId: '',
          stock: 0,
          couponCount: 0,
          winRate: 0,
          integral: 0
        };
      }
    }
  },
  data: function data() {
    return {
      couponLoading: false,
      couponList: [],
      couponReward: _objectSpread({}, this.value)
    };
  },
  watch: {
    couponReward: {
      handler: function handler(newValue) {
        if (JSON.stringify(newValue) !== JSON.stringify(this.value)) {
          this.$emit('input', _objectSpread({}, newValue)); // 发送副本以避免引用问题
        }
      },
      deep: true,
      immediate: true
    },
    value: {
      immediate: true,
      handler: function handler(newValue) {
        // 检查新值是否与当前值不同，避免不必要的更新
        if (JSON.stringify(newValue) !== JSON.stringify(this.couponReward)) {
          this.couponReward = _objectSpread({}, newValue);
        }
        if (this.couponReward.couponId && this.couponList.length <= 0) {
          this.queryCouponList(this.couponReward.couponId);
        }
      }
    }
  },
  created: function created() {},
  methods: {
    queryCouponList: function queryCouponList(query) {
      var _this = this;
      if (!query) {
        this.couponList = [];
        return;
      }
      this.couponLoading = true;
      var params = {
        couponName: query
      };
      (0, _sys_cons.queryBonusTypeCombo)(params).then(function (res) {
        _this.couponList = res.data || [];
      }).finally(function () {
        _this.couponLoading = false;
      });
    }
  }
};